import { ParamMap } from "@angular/router";
import { ItemCart, Cart, ParameterCart } from "app/models/cart-model";
import { Resumen } from "app/models/info-cart-model";
import { Item, StockModel } from "app/models/stock-model";
import { FilterModel } from "app/models/filter-model";
import * as moment from 'moment-timezone';

export class Utils {
  
  static getParams(queryParamMap: ParamMap, l?:ItemCart[]):ParameterCart{
    let query:ParameterCart = {startDate:'', endDate:'', items: [], type: null, 
      userData: { id: 0, name: "", email: "", discountCode: "", extension: "", telephoneNumber: "", agreement: false, insurance: false, langCode: "" }, 
      reservationUuid: '', commissionAgentId: null};
    if(queryParamMap!=null && queryParamMap.has('cart')){
      let queryExtracted = JSON.parse(window.atob(queryParamMap.get('cart')));
      query = { ...query, ...queryExtracted };
    }
    let parameters:ParameterCart = {
      items: (query.items || []) as ItemCart[],
      startDate: query.startDate || '',
      endDate: query.endDate || '',
      type: query.type || null,
      userData: query.userData,
      reservationUuid: query.reservationUuid || null,
      commissionAgentId: query.commissionAgentId || null
    }; 
    if(l!=undefined){
      parameters.items = l;
    }
    return parameters;
  }

  static generateParams(parameters:ParameterCart){
    return {cart:window.btoa(JSON.stringify(parameters))};
  }

   static cartRequest(parameterCart?:ParameterCart, userData?: any) {

    if(userData){
      parameterCart.userData = userData;
    }

    const cartRequest: Cart = {
        startDate: parameterCart.startDate,
        endDate: parameterCart.endDate,
        items: parameterCart.items,
        parameters: window.btoa(JSON.stringify(parameterCart)),
        userData: parameterCart.userData,
        reservationUuid: parameterCart.reservationUuid,
        commissionAgentId: parameterCart.commissionAgentId
      }

      return cartRequest;
  }


  static getTypeLockers(stock:StockModel): Item[]{
    let lockerGroup:StockModel = stock;
    if(lockerGroup==undefined) return [];
    return lockerGroup.items; //app
  }

  /*
    Devuelve los sizes de locker existentes con el límite máximo disponible.
  */
  static getSizeLockerByType(stock:StockModel, type_: number, resumen?: Resumen[]): Item[]{
    let lockerGroup:StockModel = stock;
    if(lockerGroup.items == undefined) return [];
    let type = lockerGroup.items.find(f=> f.id == type_);
    if(type == undefined) return [];
    let sizes = type.items;
    if(resumen != undefined){
      for (let size of sizes) {
        let resumenAux = resumen.find(i => i.categoryId == size.id)
        size['more'] = resumenAux != undefined ? resumenAux.more : true;
      }
    }
    return sizes;
  }

  private static hashCode(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
       hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  private static intToRGB(i){
    var c = (i & 0x00FFFFFF)
        .toString(16)
        .toUpperCase();

    return "00000".substring(0, 6 - c.length) + c;
  }

  static generateColor(str){
    return "#"+Utils.intToRGB(Utils.hashCode(str))
  }

  static convertStrToDate(dateStr: string){
    let dateArr = dateStr.split('-');
    return new Date(Date.UTC(Number(dateArr[0]), Number(dateArr[1])-1, Number(dateArr[2])));
  }

  static mapLocalDateRangeToUtc(dateRange: string[], timezone: string = 'Europe/Madrid'): string[] {
    if (!dateRange || dateRange.length < 2 || !dateRange[0] || !dateRange[1]) {
      return dateRange;
    }

    return [
      moment.tz(dateRange[0], 'YYYY-MM-DD', timezone).startOf('day').utc().format('YYYY-MM-DD HH:mm:ss'),
      moment.tz(dateRange[1], 'YYYY-MM-DD', timezone).endOf('day').utc().format('YYYY-MM-DD HH:mm:ss')
    ];
  }
      
  static generateFilters(filters:FilterModel[]):string{
    let result = '';
    filters.forEach(filter=> { 
      let value = filter.value;
      result == '' ? result += '' : result += ','; 

      if(filter.values != null && filter.values.length > 0){
        value = filter.values.join("_and_");
      }

      result += filter.field +';'+ filter.operator +';'+ value;
    });
    return 'filters=' + result;
  }


  static isObjEmpty (obj) {
    return Object.keys(obj).length === 0;
  }

  static isObjNull (obj) {
    return Object.keys(obj).length === 0;
  }
 
  static sameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() &&
      d1.getMonth() === d2.getMonth() &&
      d1.getDate() === d2.getDate();
  }
  static pastDay(d1, d2) {
    return d1 >= d2;
  }
  static futureDay(d1, d2) {
    return d1 <= d2;
  }

  /**
   * Fusiona los dos objecto y mantiene por defecto el source
   * @param target 
   * @param source default
   * @returns 
   */
  static deepMergePreserveOriginal(target, source) {
    if (typeof target !== 'object' || target === null) return source;
    if (typeof source !== 'object' || source === null) return target;
  
    const merged = Array.isArray(target) ? [...target] : { ...target };
  
    for (const key in source) {
      if (source.hasOwnProperty(key)) {
        if (!merged.hasOwnProperty(key)) {
          merged[key] = source[key];
        } else if (
          typeof merged[key] === 'object' &&
          merged[key] !== null &&
          typeof source[key] === 'object' &&
          source[key] !== null
        ) {
          merged[key] = Utils.deepMergePreserveOriginal(merged[key], source[key]);
        }
        // Si ya existe y no es objeto, se conserva el valor original
      }
    }
  
    return merged;
  }

  
}
